import React, { useContext } from 'react'
import { styled } from '@mui/material'
import { Typography } from '@mui/material'
import { SectionContext } from '../Section/Context'

const Wrapper = styled('div')`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 80px;
`

export const SectionContentMarketGigsWrapper: React.FunctionComponent<{
  children: React.ReactNode
  marketCity: string
}> = ({ marketCity, children }) => {
  const { theme } = useContext(SectionContext)

  return (
    <Wrapper>
      <Typography
        variant="h2"
        sx={{
          color: theme === 'dark' ? 'primary.contrastText' : 'textPrimary',
        }}
        align="center"
      >
        Check out the latest Gigs in {marketCity}
      </Typography>
      {children}
    </Wrapper>
  )
}
